import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const Toast = ({ message }) => (
  <div
    className="toast-animation"
    style={{
      position: 'fixed',
      width: 'calc(100% - 10px)',
      maxWidth: '400px',
      height: '50px',
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      borderRadius: '4px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
      margin: '0 auto',
      left: 0,
      right: 0,
      opacity: 0,
      zIndex: 1001,
    }}
  >
    <span
      style={{
        textAlign: 'center',
        color: 'white',
        position: 'absolute',
        width: '100%',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        paddingLeft: '10px',
        paddingRight: '10px',
      }}
    >
      {message || 'Connection error'}
    </span>
  </div>
);

Toast.defaultProps = {
  intl: null,
  message: null,
};
Toast.propTypes = {
  message: PropTypes.string,
};

export const showRenderToast = (props, timer = 3000, callback) => {
  const toast = document.getElementById('toast');

  if (!toast) {
    return;
  }

  const renderCallback = callback || null;
  const { message } = props;
  setTimeout(() => {
    ReactDOM.unmountComponentAtNode(toast);
  }, timer);
  ReactDOM.render(<Toast message={message} />, toast, renderCallback);
};
// export default Toast;
export default Toast;
